import React from 'react';
import {
  Grid,
  TextField,
  InputAdornment,
  Autocomplete,
  Typography,
} from '@mui/material';
import { Home, Apartment, Public } from '@mui/icons-material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const COUNTRIES = ['United Kingdom'];

const AddressForm = ({
  address,
  onAddressChange,
  disabled,
  description,
  errors,
}) => {
  const handleFieldChange = (field) => (e) => {
    onAddressChange(field, e.target.value);
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {description}
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Building and street *"
          name="street"
          value={address?.street || ''}
          onChange={handleFieldChange('street')}
          margin="normal"
          disabled={disabled}
          error={!!errors?.street}
          helperText={errors?.street}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Home fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="City *"
          name="city"
          value={address?.city || ''}
          onChange={handleFieldChange('city')}
          disabled={disabled}
          margin="normal"
          error={!!errors?.city}
          helperText={errors?.city}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Apartment fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Postcode *"
          name="postalCode"
          value={address?.postalCode || ''}
          onChange={handleFieldChange('postalCode')}
          margin="normal"
          error={!!errors?.postalCode}
          helperText={errors?.postalCode}
          disabled={disabled}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationOnIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Autocomplete
          freeSolo
          disabled
          options={COUNTRIES}
          value={address?.country || 'United Kingdom'}
          onChange={(e, newValue) => onAddressChange('country', newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Country *"
              margin="normal"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <Public fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default AddressForm;
